import React from 'react'
import timg from '../../assets/t.png'
import img from '../../assets/others/11102068.jpg'
import './Authabout.css'



const Authabout = () => {
  return (
    <div class="aut-abt-section ws-section pb-05">
        <div class="container text-center">
                    <div class="row mb-lg-5 justify-content-center pb-lg-5">
                        <div class="col-lg-9">
                            <h2 class="ws-section_heading pd-03 mb-1">Message From Our CEO</h2>
                            <p class="text-lg text-sm-2xl">Our vision is to revolutionize the VLSI industry by pioneering cutting-edge solutions that drive innovation and excellence in semiconductor design. Together, we will shape the future of technology with precision and efficiency.</p>
                        </div>
                    </div>
                    <div class="row txt-lt  justify-content-around">
                        <div class="col-lg-6 mb-3">
                            <div class="pt-5 bg-4 radius-1 p-5 bg-timg ">
                            <p class="text-lg text-sm-2xl mt-4 pb-4">Our vision is to lead the VLSI industry by delivering groundbreaking semiconductor solutions that power the next generation of technology. We are committed to driving innovation, enhancing efficiency, and pushing the limits of what’s possible in chip design. By fostering a culture of collaboration and excellence, we aim to revolutionize industries and create lasting impact.</p>
                            <figcaption class="mt-6"><h5 class="body-font font-semibold text-2xl">Venkat</h5><div class="font-semibold text-lg mb-5">Founder, CEO</div></figcaption>
                           </div>
                        </div>
                        <div class="col-lg-5 img-sec align-self-end img-radius mb-3">
                            <img src={img} alt=''/>
                        </div>
                    </div>
         </div>
     </div>
  )
}

export default Authabout